import { Action, Selector, State, StateContext } from '@ngxs/store';
import { switchMap, tap, pluck } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TerminalLog } from '../models';
import { TerminalLogService } from '../services/terminal-log.service';
import { DeleteTerminalLog, GetTerminalLogs } from '../actions/terminal-log.actions';


@State<TerminalLog.State>({
    name: 'TerminalLog',
    defaults: {
        logs: {} as TerminalLog.TerminalLogReponse
    } as TerminalLog.State,
})
@Injectable()
export class TerminalLogState {


    @Selector()
    static logs({ logs }: TerminalLog.State) {
        return logs.items;
    }

    @Selector()
    static logTotalcount({ logs }: TerminalLog.State) {
        return logs.totalCount;
    }

    constructor(
        private service: TerminalLogService
    ) {

    }

    @Action(GetTerminalLogs)
    getTerminalLogs({ patchState }: StateContext<TerminalLog.State>, { payload }: GetTerminalLogs) {
        return this.service.getTerminalLogs(payload).pipe(
            tap(
                response => patchState({ logs: response })
            )
        )
    }

    @Action(DeleteTerminalLog)
    deleteTerminalLog(_, { id }: DeleteTerminalLog) {
        return this.service.delete(id);
    }
}